/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@compiled/react';
import { FormattedMessage, useIntl } from 'react-intl-next';

import Badge from '@atlaskit/badge';
import ErrorIcon from '@atlaskit/icon/core/status-error';
import { Inline } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';

import { MAX_RELATED_EVENTS_RETURNED_COUNT } from '../../../common/utils/constants';

export const messages = {
	relatedActivitiesTab: {
		id: 'organization.audit.log.side-panel.tabs.related-activities.tab',
		defaultMessage: 'Related activities',
		description: 'Title of the audit log side panel tab related activities',
	},
	relatedActivitiesTabBadgeError: {
		id: 'organization.audit.log.side-panel.tabs.related-activities.tab.badge.error',
		defaultMessage: 'You encountered an error while loading related activities',
		description: 'Error message for when loading related activties encounters an error',
	},
};

interface RelatedActivitiesTabProps {
	hasError?: boolean;
	hasMoreEvents: boolean;
	isLoading?: boolean;
	isSelected?: boolean;
	totalEventsCount: number;
}

export const RelatedActivitiesTab = ({
	isLoading = false,
	hasError = false,
	hasMoreEvents,
	totalEventsCount,
	isSelected = false,
}: RelatedActivitiesTabProps): JSX.Element => {
	const { formatMessage } = useIntl();
	// add 1 to related events count to get 30+ in tab badge
	const numRelatedEvents = hasMoreEvents ? totalEventsCount + 1 : totalEventsCount;

	return (
		<Inline space="space.050" alignBlock="center">
			<FormattedMessage {...messages.relatedActivitiesTab} />
			{isLoading ? (
				<Spinner size="xsmall" />
			) : hasError ? (
				<ErrorIcon
					spacing="spacious"
					color={token('color.icon.danger', '#AE2E24')}
					label={formatMessage(messages.relatedActivitiesTabBadgeError)}
				/>
			) : (
				<Badge
					appearance={isSelected ? 'primary' : 'default'}
					max={MAX_RELATED_EVENTS_RETURNED_COUNT}
				>
					{numRelatedEvents}
				</Badge>
			)}
		</Inline>
	);
};
